import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function StoriesSection() {
  const stories = [{
    name: 'Marcus Chen',
    before: 'College dropout, no direction',
    after: 'Regional Manager, $140K/year',
    quote: 'The Forge gave me structure when I had none. Now I lead a team of 12.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop'
  }, {
    name: 'Sarah Mitchell',
    before: 'Retail worker, $32K/year',
    after: 'Sales Director, $180K/year',
    quote: 'I went from surviving to thriving. The pressure made me unbreakable.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop'
  }, {
    name: 'David Torres',
    before: 'Failed entrepreneur, broke',
    after: 'Territory Leader, $165K/year',
    quote: 'The Forge taught me that discipline beats motivation every single time.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop'
  }];
  return <section id="stories" className="py-32 px-6 bg-[var(--forge-charcoal)] relative" data-id="element-132">
      <div className="max-w-7xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-134">
          <h2 className="text-5xl md:text-6xl font-black tracking-tighter mb-4" data-id="element-135">
            <span className="text-[var(--forge-lava)]" data-id="element-136">FORGED</span> STORIES
          </h2>
          <p className="text-xl text-[var(--forge-gray)]" data-id="element-137">
            Real people. Real transformations.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-138">
          {stories.map((story, index) => <motion.div key={story.name} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-[var(--forge-steel)] border border-[var(--forge-zinc)]/30 overflow-hidden group cursor-pointer" data-id="element-139">
              <div className="aspect-square overflow-hidden" data-id="element-140">
                <img src={story.image} alt={story.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-500" data-id="element-141" />
              </div>

              <div className="p-6" data-id="element-142">
                <h3 className="text-2xl font-black mb-4" data-id="element-143">{story.name}</h3>

                <div className="space-y-2 mb-4" data-id="element-144">
                  <div className="text-sm" data-id="element-145">
                    <span className="text-[var(--forge-gray)]" data-id="element-146">Before:</span>
                    <span className="text-[var(--forge-white)] ml-2" data-id="element-147">
                      {story.before}
                    </span>
                  </div>
                  <div className="text-sm" data-id="element-148">
                    <span className="text-[var(--forge-lava)] font-semibold" data-id="element-149">
                      After:
                    </span>
                    <span className="text-[var(--forge-white)] ml-2 font-semibold" data-id="element-150">
                      {story.after}
                    </span>
                  </div>
                </div>

                <p className="text-[var(--forge-gray)] italic mb-4 leading-relaxed" data-id="element-151">
                  "{story.quote}"
                </p>

                <button className="flex items-center gap-2 text-[var(--forge-lava)] font-semibold text-sm group-hover:gap-4 transition-all" data-id="element-152">
                  Read story <ArrowRightIcon className="w-4 h-4" data-id="element-153" />
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}